import { Stack, Typography } from '@mui/material';
import GuestBase from './guestBase';
import { useNavigate } from 'react-router-dom';
import { useNuralogixApi } from '../../api/nuralogix';
import { getOperatingSystem } from '../../utils/miscellaneous';
import { useState } from 'react';
import FaceScanInstruction from '../../components/faceScanInstruction/faceScanInstruction';

export const GuestPreFaceScan = () => {
  const navigate = useNavigate();
  const api = useNuralogixApi();
  const [ isShowBrightnessInstructionScreen, setIsShowBrightnessINstructionScreen] = useState(false)

  const handleNext = async () => {
    if(isShowBrightnessInstructionScreen){
    const deviceType = getOperatingSystem();
    const url = await api.postNuralogixUrlAnon(deviceType);
    if (url.data?.redirect_url) {
      window.location.href = url.data.redirect_url;
    }
  } else{
    setIsShowBrightnessINstructionScreen(true)
  }
};



  return (
    <GuestBase onPrev={ () => navigate( '/guest-demographics' ) } onNext={ handleNext }>
      <Stack className='guest-box'>
     { !isShowBrightnessInstructionScreen ?
        <Stack sx={ { p: 3, textAlign: 'center' } } spacing={ 3 } className='guest-wrapper'>
          <Typography
            sx={ {
              fontWeight: 700,
              fontSize: "23px",
              color : "#30373E"
            } }
          >
            {/* Next, we will scan your face to take your vital signs! */}
            Now, we will scan your face to measure your biomarkers. 
          </Typography>
          {/* <Typography>This system is based on assessing the blood flow in your face.</Typography> */}
          <Typography>
          Based on these results, we can curate product recommendations <br/>that will work specifically for you. 
      
          </Typography>
          <Typography >
            {/* It is important to note that it works best on people with no makeup and who have less facial hair. */}
            💡 Please make sure you are in a brightly lit area and the light is spread evenly on your face. Remove your hat and eyeglasses and stay close to the camera and still during the 30-second scan to get a good measurement.
          </Typography>
          {/* <Typography sx={ { fontWeight: 700 } }>
            Make sure you are in a brightly lit room and the light is spread evenly across your face.
          </Typography> */}
          </Stack>
        :
        <Stack sx={ { p: 3, textAlign: 'center' } } spacing={ 3 } className='guest-wrapper'>
        <FaceScanInstruction></FaceScanInstruction>
        </Stack>
     }
        
      </Stack>

    </GuestBase>
  );
};

export default GuestPreFaceScan;
